import React, { useEffect, useRef, useState } from 'react';
import EventLabel from '../EventLabel/EventLabel';
import { basedAxios as Axios } from '../../store/Store';

const POLL_MS = 30000;

const formatRemaining = totalSeconds => {
  const s = Math.max(0, totalSeconds);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d}d ${h}h ${m}m`;
  if (h > 0) return `${h}h ${m}m ${sec}s`;
  return `${m}m ${sec}s`;
};

export const EventNotPublic = ({ layoutCode, publishAt, secondsUntilPublish }) => {
  const [secondsLeft, setSecondsLeft] = useState(secondsUntilPublish);
  const pollRef = useRef();
  const tickRef = useRef();

  const checkNowPublic = () => {
    Axios.get(`./cms/${layoutCode}/?newSqlStateNo=false`)
      .then(({ data }) => {
        if (!data.notPublic) window.location.reload();
      })
      .catch(() => {});
  };

  useEffect(() => {
    pollRef.current = setInterval(checkNowPublic, POLL_MS);
    return () => clearInterval(pollRef.current);
  }, []);

  useEffect(() => {
    if (secondsLeft == null) return undefined;
    tickRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev != null && prev <= 1) {
          checkNowPublic();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(tickRef.current);
  }, [secondsLeft == null]);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontFamily: 'Be Vietnam' }}>
        <EventLabel name="EventNotPublicTitle" groupName="CMS.EventNotPublic" defaultValue="This page is not available" />
      </h1>
      <h4 style={{ fontFamily: 'Be Vietnam', maxWidth: 500 }}>
        <EventLabel name="EventNotPublicBody" groupName="CMS.EventNotPublic" defaultValue="Please check back later." />
      </h4>
      {publishAt != null && secondsLeft != null && (
        <h4 style={{ fontFamily: 'Be Vietnam', maxWidth: 500 }}>
          <EventLabel name="EventOpensAt" groupName="CMS.EventNotPublic" defaultValue="Opens in" /> {formatRemaining(secondsLeft)}
        </h4>
      )}
    </div>
  );
};

export default EventNotPublic;
